<template>
  <van-popup 
    v-model="open"
    round
    lock-scroll
  >
    <div class="popup-body">
      <div class="tabs-list" v-if="list && list.length">
        <van-tabs 
          v-model="listCurrent" 
          line-width="20"
          :ellipsis="false"
          @change="listTabsChange"
        >
          <van-tab 
            :title="listItem.carType"
            title-style="font-size: 16px;"
            v-for="listItem in list" :key="listItem.id"
          ></van-tab>
        </van-tabs>
      </div>
      <van-swipe ref="swipe" :loop="false" :show-indicators="false" v-if="list && list.length" @change="handleSwipeChange">
        <van-swipe-item v-for="childrenItem in list[listCurrent].children" :key="childrenItem.id">
          <div style="display: flex;align-items: center;">
            <van-image
              width="162"
              height="108"
              style="margin: 0px 0 0px 0;flex-shrink: 0;"
              :src="childrenItem.carPicture"
              @click="handleImagePreview({ childrenList:list[listCurrent].children , src: childrenItem.carPicture })"
            ></van-image>
            <div class="describe">{{ list[listCurrent].introduce }}</div>
          </div>
          <div class="parameter">
            <div class="parameter-item">
              <div>规格：</div>
              <div>{{childrenItem.lengthRange?childrenItem.lengthRange:'--'}}m*{{childrenItem.wideRange?childrenItem.wideRange:'--'}}m*{{childrenItem.highRange?childrenItem.highRange:'--'}}m</div>
            </div>
            <div class="parameter-item">
              <div>车辆净重：</div>
              <div>{{childrenItem.carWeight}}T</div>
            </div>
            <div class="parameter-item">
              <div>卡板数：</div>
              <div>{{childrenItem.cardBoardNumber}}板</div>
            </div>
            <div class="parameter-item">
              <div>装载体积：</div>
              <div>{{childrenItem.cargoVolumeRange?childrenItem.cargoVolumeRange+'m³':'--'}}</div>
            </div>
            <div class="parameter-item">
              <div>最大载重：</div>
              <div>{{childrenItem.loadRange?childrenItem.loadRange.split("-")[1]+'T':'--'}}</div>
            </div>
            <div class="parameter-item">
              <div>装备质量：</div>
              <div>{{childrenItem.curbWeight}}T</div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
      <div class="children-tabs" v-if="list && list.length">
        <div 
          class="children-tabs-item" 
          :class="{'children-tabs-item-active': childrenIndex === childrenCurrent}"
          v-for="(childrenTab,childrenIndex) in list[listCurrent].children" :key="childrenTab.id"
          @click="handleChildrenTabsClick(childrenIndex)"
        >{{ childrenTab.beecargoCarTypeName }}</div>
      </div>
      <!-- <div class="tabs-children-list" v-if="list && list.length">
        <van-tabs 
          type="card" 
          color="#EC892E"
          swipeable
          :ellipsis="false"
          v-model="childrenCurrent" 
          ref="childrenTabs"
        >
          <van-tab 
            :title="childrenItem.beecargoCarTypeName"
            v-for="childrenItem in list[listCurrent].children" :key="childrenItem.id"
          >
            <div style="display: flex;align-items: center;">
              <van-image
                width="162"
                height="108"
                style="margin: 0px 0 0px 0;flex-shrink: 0;"
                :src="childrenItem.carPicture"
                @click="handleImagePreview({ childrenList:list[listCurrent].children , src: childrenItem.carPicture })"
              ></van-image>
              <div class="parameter">{{ list[listCurrent].introduce }}</div>
              <div>
                <div style="display:flex;align-items:center;">
                  <div class="parameter">载重：{{ childrenItem.loadRange ? childrenItem.loadRange : "0" }}T</div>
                </div>
                <div class="parameter">长宽高：{{childrenItem.lengthRange}}m*{{childrenItem.wideRange}}m*{{childrenItem.highRange}}m</div>
                <div class="parameter">装载体积：{{childrenItem.cargoVolumeRange}}m³</div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div> -->
    </div>
  </van-popup>
</template>

<script>
import { Popup , Tab, Tabs , Image ,Icon , Swipe, SwipeItem } from 'vant';
export default {
  components:{ 
    [Popup.name]:Popup,
    [Tab.name]:Tab,
    [Tabs.name]:Tabs,
    [Image.name]:Image,
    [Icon.name]:Icon,
    [Swipe.name]:Swipe,
    [SwipeItem.name]:SwipeItem,
  },
  inject:["imagePreview"],
  data(){
    return {
      open:false,
      list:[],
      listCurrent:0,
      childrenCurrent:0,
      initialData:null
    }
  },
  mounted(){
    this.initialData = this.deepClone(this.$data);
  },
  methods:{
    show(options){
      this.reset();
      this.init(options);
      this.open = true;
      this.$nextTick(()=>{
        this.transLateListChildren();
      })
    },
    reset(){
      Object.keys(this.initialData).map(key => {
        if(key === "initialData") return false;
        this[key] = this.initialData[key];
      })
    },
    init(options){
      if(!options || Object.prototype.toString.call(options) !== "[object Object]") return false;
      Object.keys(options).map(key => {
        this[key] = options[key];
      });
    },
    // 预览图片
    handleImagePreview({ childrenList , src }){
      let images = childrenList.map(childrenItem=>childrenItem.carPicture).filter(item=>item);
      this.imagePreview({ images , src });
    },
    listTabsChange(){
      this.childrenCurrent = 0;
      this.$refs["swipe"].swipeTo(0);
      this.$refs["childrenTabs"].resize();
      this.$nextTick(()=>{
        this.transLateListChildren();
      })
    },
    // 轮播改变
    handleSwipeChange(index){
      this.childrenCurrent = index;
    },
    handleChildrenTabsClick(index){
      this.$refs["swipe"].swipeTo(index);
    },
    // 移动
    transLateListChildren(){
      let tabsDom = document.querySelectorAll(".van-popup--center .van-tabs__wrap")[1];
      let contentDom = document.querySelectorAll(".van-popup--center .van-tabs__content")[1];
      tabsDom.style.transform = `translateY(${contentDom.offsetHeight}px)`;
      contentDom.style.transform = `translateY(-${tabsDom.offsetHeight}px)`;
    },
  }
}
</script>

<style scoped lang="scss">
  
  .popup-body {
    .describe {
      height: 108px;
      font-size: 12px;
      line-height: 28px;
      color: #C9C2BB;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp:4;
      display:-webkit-box;
      -webkit-box-orient:vertical;
    }
    .parameter {
      display: grid;
      grid-template-columns: 1.5fr 1fr 1fr;
      grid-row-gap: 10px;
      font-size: 14px;
      line-height: 22px;
      padding: 0 16px 15px 16px;
    }
    .children-tabs {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 15px;
      margin: 0 16px;
      border-top: 1px solid #E3E3E3;
      .children-tabs-item {
        height: 28px;
        font-size: 12px;
        line-height: 28px;
        text-align: center;
        border-radius: 8px;
        padding: 0 6px;
        overflow: hidden;
        border: 1px solid #E3E3E3;
        color: #A4A4A4;
        margin: 15px 10px 0 0;
      }
      .children-tabs-item-active {
        color: #F1892E;
        border-color: #F1892E;
      }
    }
  }
  .tabs-list {
    ::v-deep .van-tabs__wrap {
      height: 39px;
      .van-tabs__line {
        bottom: 18px;
        background-color: #EC892E !important;
      }
      .van-tab--active {
        .van-tab__text {
          color: #EC892E;
          font-weight: bold;
        }
      }
    }
  }
  ::v-deep .tabs-children-list {
    .van-tabs__nav--card {
     border: none;
     .van-tab {
       border: none;
       color: #3D3833 !important;
     }
     .van-tab--active {
       border-radius: 8px;
       color: #FFF !important;
     }
   }
  }
  ::v-deep.van-popup--center {
    width: 351px !important;
  }
</style>